import type { STMatrixData } from '@types';
import { createApi, createDomain } from 'effector';
import { createGate } from 'effector-react';
import produce from 'immer';
import { $curSandTableId } from './dataStores';

const domain = createDomain('sandTable');

export const $sandTableLoaded = domain.store(false).reset($curSandTableId);
export const $sandTableLoadedApi = createApi($sandTableLoaded, {
  on: () => true,
  off: () => false,
});

export const $sandTableMatrixMap = domain.store<Map<number, STMatrixData>>(
  new Map()
);
export const $sandTableMatrixMapApi = createApi($sandTableMatrixMap, {
  add: (state, payload: STMatrixData[]) => {
    return produce(state, (draft) => {
      payload.forEach((x) => {
        draft.set(x.id, x);
      });
    });
  },
  clear: () => $sandTableMatrixMap.defaultState,
});

export const $stMapSettingPanel = domain.store(false);
export const $stMapSettingPanelApi = createApi($stMapSettingPanel, {
  on: () => true,
  off: () => false,
  toggle: (state) => !state,
});

export const $stImageSettingPanel = domain.store(false);
export const $stImageSettingPanelApi = createApi($stImageSettingPanel, {
  on: () => true,
  off: () => false,
  toggle: (state) => !state,
});

export const $GateSandtableBatchMode = createGate<boolean>({
  defaultState: false,
  domain,
});

export const $GateSandtableGroupMode = createGate<boolean>({
  defaultState: false,
  domain,
});
